module.exports = __webpack_public_path__ + "static/media/Clock_Icon.dc9fc3c0.svg";